import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SupportIcon = ({ color = '#fff', size = 15, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.875 8.531c0-.724-.588-1.312-1.313-1.312h-.656a2.625 2.625 0 0 0-2.625 2.625v1.969a2.625 2.625 0 0 0 2.625 2.624h.657c.724 0 1.312-.587 1.312-1.312V8.531zm7.219 5.906a2.625 2.625 0 0 0 2.625-2.624v-1.97a2.625 2.625 0 0 0-2.625-2.624h-.656c-.725 0-1.313.588-1.313 1.312v4.594c0 .725.588 1.313 1.313 1.313h.656zM10.5 0C4.642 0 .188 4.874 0 10.5v.656c0 .363.294.656.656.656h.656a.656.656 0 0 0 .657-.656V10.5c0-4.704 3.827-8.531 8.531-8.531 4.704 0 8.531 3.827 8.531 8.531h-.005c.004.1.005 6.797.005 6.797 0 .958-.776 1.734-1.734 1.734h-4.172a1.969 1.969 0 0 0-1.969-1.968H9.844a1.969 1.969 0 1 0 0 3.937h7.453A3.703 3.703 0 0 0 21 17.297V10.5C20.812 4.874 16.358 0 10.5 0z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

SupportIcon.propTypes = propTypes;

export default SupportIcon;
